import { FAKE_PHONE_EMAIL_HOST, FAKE_TELEGRAM_EMAIL_HOST } from '../constants/fakeEmails';

/**
 * Проверяет, является ли строка fake telegram email.
 *
 * @param {string | undefined} email — строка email
 * @returns {boolean}
 */
export function isFakeTelegramEmail(email: string | undefined): boolean {
  if (email === undefined || email === '') {
    return false;
  }
  return email.endsWith(FAKE_TELEGRAM_EMAIL_HOST);
}

/**
 * Проверяет, является ли строка fake phone email.
 *
 * @param {string | undefined} email — строка email
 * @returns {boolean}
 */
export function isFakePhoneEmail(email: string | undefined): boolean {
  if (email === undefined || email === '') {
    return false;
  }
  return email.endsWith(FAKE_PHONE_EMAIL_HOST);
}

/**
 * Проверяет, относится ли email к внутренним «фейковым» хостам Mitgo ID.
 *
 * @param {string} email — непустая строка
 * @returns {boolean}
 * @throws {Error} если аргумент не строка
 */
export function isFakedEmail(email: string): boolean {
  if (email === '' || typeof email !== 'string') {
    throw new Error('isFakedEmail: email must be a non-empty string');
  }
  return isFakeTelegramEmail(email) || isFakePhoneEmail(email);
}
